import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '../../store'

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);


// 加载标题
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
// 加载模板
import template from '../index/views/template'
Vue.use(template)
//点击复制内容
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
// 加载插件
import components from '../../plugins'
Vue.use(components)
// 图片懒加载
import VueLazyLoad from 'vue-lazyload';
Vue.use(VueLazyLoad, {
  // preLoad: 1.3, // 预加载高度的比例
  error: require("../../assets/img/loading.gif"), // 加载失败图片
  loading: require("../../assets/img/loading.gif"), // 加载中图片
  attempt: 3, // 尝试加载次数
  // 不常用参数的一些说明
  // 懒加载模块，滚动到对应视图区域之前才加载该模块，模块内容较多时不推荐使用
  // 加载速度可能会为用户带来不好的体验，适用于一些信息模块，或者一些非主体模块，适用于少部分用户关注的模块
  lazyComponent: true,
  // 默认的方法有['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend']
  listenEvents: ['scroll'],
})




Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
